import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=41040172"
import script from "./ProfileAddress.vue?vue&type=script&lang=js"
export * from "./ProfileAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports